<template>
  <div :class="[ isModal ? 'versus_action' : 'chat_action']">
    <input type="image"
           src="static/images/versus_icon.svg"
           @click.prevent="actionOnClick()"
           alt="Submit">
  </div>
</template>

<script>
export default {
  name: 'versus',
  props: {
    isModal: Boolean,
    actionOnClick: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/shared/Versus.vue